/** Pipeline stages, win probabilities, targets and the lead lifecycle. */
import { useApp } from '../../store/AppContext.jsx';
import { Section, Grid, Chips, NumberField, SelectField } from './SettingsBits.jsx';

export default function SalesPane() {
  const { S, updateSettings } = useApp();

  const setProbability = (stage, value) => updateSettings(next => {
    next.probs = next.probs || {};
    next.probs[stage] = Math.max(0, Math.min(100, parseInt(value, 10) || 0));
  });

  return (
    <>
      <Section title="Pipeline stages" hint="The columns on the board, in order. Won and Lost close a deal.">
        <Chips listKey="stages" />
      </Section>

      <Section
        title="Win probability per stage"
        hint="Drives the weighted forecast. A deal can override this individually."
      >
        <Grid>
          {(S.stages || []).map(stage => (
            <div className="num" key={stage}>
              <label>{stage}</label>
              <input
                type="number"
                min="0"
                max="100"
                value={(S.probs || {})[stage] ?? 0}
                onChange={e => setProbability(stage, e.target.value)}
              />
              <small>percent</small>
            </div>
          ))}
        </Grid>
      </Section>

      <Section title="Targets and timing">
        <Grid>
          <NumberField
            label="Monthly target"
            name="target"
            unit={`${S.currency || 'AED'} won per month`}
            min={0}
            max={100000000}
          />
          <NumberField
            label="Deal is stale after"
            name="stallDays"
            unit="days with no logged contact"
            min={1}
            max={120}
          />
        </Grid>
      </Section>

      <Section
        title="Demo follow-ups"
        hint="Who a demo follow-up goes to when nobody has said. Partners and customers are worked by different people, so each has its own default."
      >
        <Grid>
          <SelectField
            label="B2B partner follow-ups"
            name="b2bOwner"
            options={[['', '— leave unassigned —'], ...(S.owners || []).map(o => [o, o])]}
          />
          <SelectField
            label="B2C customer follow-ups"
            name="b2cOwner"
            options={[['', '— leave unassigned —'], ...(S.owners || []).map(o => [o, o])]}
          />
        </Grid>
      </Section>

      <Section title="Contact statuses" hint="Lead lifecycle before they become a client.">
        <Chips listKey="lStatus" />
      </Section>

      <Section title="Industries"><Chips listKey="industries" /></Section>
      <Section title="Activity types"><Chips listKey="actTypes" /></Section>
    </>
  );
}
